<template>
    <v-container pt-0 style="max-width: 100% !important">
        <v-data-table :headers="table_headers" :items="['1']" hide-actions>
            <template slot="items">
                <tr v-for="(header, index) in row_headers" :key="index">
                    <td style="padding-left: 10px">
                        <small style="position: absolute; left: 0px"
                            ><strong>{{ header.sort_order ? `(${header.sort_order})` : "" }}</strong></small
                        ><strong>{{ header.header }}</strong>
                        <br v-if="header.method || header.parameter" />
                        <p v-if="header.method != null" style="font-size: 80%; margin-bottom: 0px !important">Method: {{ header.method }}</p>
                        <p v-if="header.parameter != null" style="font-size: 80%; margin: 0px !important">Parameter: {{ header.parameter }}</p>
                        <p v-if="header.frequency != null" style="font-size: 80%; margin: 0px !important">Frequency: {{ header.frequency }}</p>
                    </td>
                    <!-- <td>{{ item[header] }}</td> -->
                    <!-- iterate through all the logs and their log details and get the user value based on the question -->
                    <td v-for="(log, index) in logs" :key="index">
                        <div v-if="header.header == 'Operator'">
                            {{ log.created_by }}
                        </div>
                        <div v-for="(log_detail, index) in log.logs_detail">
                            <div v-if="log_detail.detail_template_id == header.detail_template_id">
                                {{ log_detail.user_value }}
                            </div>
                        </div>
                    </td>
                </tr>
            </template>
        </v-data-table>
    </v-container>
</template>

<script>
export default {
    name: "hourly_operation_log_table",
    props: {
        slug: {
            type: String,
            required: true,
        },
        logs: {
            type: Array,
            required: true,
        },
        log_template: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            row_headers: [],
            table_headers: [{ text: "Item", sortable: false, width: "256px" }],
        };
    },
    watch: {
        logs: {
            handler: function (val) {
                this.table_headers = [{ text: "Item", sortable: false, width: "256px" }];
                for (let i = 0; i < this.logs.length; i++) {
                    this.table_headers.push({ text: this.logs[i].date_created, sortable: false });
                }
            },
            deep: true,
        },
    },
    computed: {},
    activated() {
        this.row_headers.push({ header: "Operator" });
        for (let i = 0; i < this.log_template.log_templates_detail.length; i++) {
            this.row_headers.push({
                header: this.log_template.log_templates_detail[i].question,
                detail_template_id: this.log_template.log_templates_detail[i].detail_template_id,
                method: this.log_template.log_templates_detail[i].method ? this.log_template.log_templates_detail[i].method : null,
                parameter: this.log_template.log_templates_detail[i].parameter ? this.log_template.log_templates_detail[i].parameter : null,
                frequency: this.log_template.log_templates_detail[i].frequency ? this.log_template.log_templates_detail[i].frequency_display : null,
                sort_order: this.log_template.log_templates_detail[i].sort_order,
            });
        }

        for (let i = 0; i < this.logs.length; i++) {
            this.table_headers.push({ text: this.logs[i].date_created, sortable: false });
        }
    },
};
</script>
